export const version = "web/5.4.0";
//# sourceMappingURL=_version.js.map